import { JourneyStatsWindow } from '@/services/lifecycleAPI';

export const MIN_ARM_SIZE = 30;
export const MIN_GOALS = 5;
export const STOP_RATE_MIN_SMS = 50;
export const STOP_RATE_LIMIT = 0.02;

// The rates and p_value are computed over the journeys whose whole window
// ended in the period, whatever the outcome, and that entered live (graphy
// JourneyStatsService#window_stats, review R3-01 and R3-04), one count per
// arm. The gate and the "n" line must count those same people: the exit
// counts include journeys that entered earlier and both arms, and `holdout`
// includes active entries, so a lift from a 3-person holdout passed the gate
// (bug hunt 17). The fallbacks keep an older graphy working.
export const closedEntries = (stats: JourneyStatsWindow) =>
  stats.closed_journey ??
  stats.exited_goal +
    stats.exited_window +
    stats.exited_superseded +
    stats.exited_suppressed;

export const closedHoldout = (stats: JourneyStatsWindow) =>
  stats.closed_holdout ?? stats.holdout;

export const hasEnoughData = (stats: JourneyStatsWindow) =>
  closedEntries(stats) >= MIN_ARM_SIZE &&
  closedHoldout(stats) >= MIN_ARM_SIZE &&
  (stats.closed_journey_goals ?? stats.exited_goal) >= MIN_GOALS;

export const isStopRateRed = (smsSentIn7Days: number, rate: number) =>
  smsSentIn7Days >= STOP_RATE_MIN_SMS && rate > STOP_RATE_LIMIT;
